import type { NetworkStoreRanking, NetworkStoreRankingSelectionParams } from '@gozoki/api-types'
import { keepPreviousData, type UseQueryResult, useQuery } from '@tanstack/react-query'
import { fetchNetworkStoreRanking } from '../queries/networkStoreRanking.queries'

export const useNetworkStoreRanking = (
  selection: NetworkStoreRankingSelectionParams,
  enabled = true,
): UseQueryResult<NetworkStoreRanking, unknown> =>
  useQuery({
    queryKey: [
      'get-network-store-ranking',
      selection.storeIds,
      selection.storeAgeFilter,
      selection.ageStoreIds,
      selection.startDate,
      selection.endDate,
      selection.comparableStartDate,
      selection.comparableEndDate,
    ],
    queryFn: () => fetchNetworkStoreRanking(selection),
    placeholderData: keepPreviousData,
    enabled,
  })
